module.exports = __webpack_public_path__ + "assets/img/burst_mercedes.6293f835.png";